<template>
  <div class="content-container">
    <search-comp @onSearch="getList" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    :disabled="disabledDate"
                    multiple
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    />
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Recode</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <input
                    v-model="searchParams.bookingCode"
                    type="text"
                    @keypress="clsAlphaNoOnly"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nguồn</div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    :rows="sourceOptions"
                    :columns="columnsSource"
                    :dropdown-width="400"
                    index-field="id"
                    :selected-index-field-value="searchParams.sourceId"
                    :disabled="disabledDate"
                    :value="searchParams.sourceId"
                    @selectionChanged="onSelectRowSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.code }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.agentId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in agentOptions"
                      :key="index"
                      :value="item.id"
                      :label="`(${item.code}) ${item.name || ''}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Từ ngày - Đến ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    :disabled="disabledDate"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo chi tiết phòng miễn phí</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              row-selection="false"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :pinned-bottom-row-data="pinnedBottomRowData"
              :auto-select-first-row="false"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Tên phòng: hiển thị tên phòng</li>
            <li>Số lượng khách: hiển thị số lượng khách trong phòng</li>
            <li>Hạng phòng: hạng phòng của đặt phòng</li>
            <li>Tên khách: Hiển thị tên khách chính của đặt phòng</li>
            <li>Nguồn: Hiển thị nguồn của đặt phòng</li>
            <li>
              Giá niêm yết: Hiển thị giá phòng được niêm yết (Giá thiết kế)
            </li>
            <li>Ngày đến: Ngày khách dự kiến đến, format DDMMYYYY</li>
            <li>Ngày đi: Ngày khách dự kiến đi, format DDMMYYYY</li>
            <li>
              Dịch vụ thêm: Hiển thị dịch vụ mà đặt phòng đã sử dụng thêm (từ
              bảng code)
            </li>
            <li>Ghi chú: hiển thị ghi chú khi đặt phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import {
  getFreeListApi,
  getFreeListApiExcel
} from '@/api/report_service/report_b'
import { getAgentListForReport } from '@/api/report_service/takeMoneybyInvoice'
import InfoBtn from './components/InfoBtn.vue'
import { getList } from '@/api/houseKeeper/lost-and-found'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    SelectWithSearchTable,
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      disabledDate: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      pinnedBottomRowData: [],
      dialogFormVisible: false,
      hotelList: [],
      agentOptions: [],

      loading: false,

      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelId: [],
        bookingCode: null,
        sourceId: null,
        agentId: null
      },
      searchParamsDefault: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelId: [],
        bookingCode: null,
        sourceId: null,
        agentId: null
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          tooltipField: 'code',
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          tooltipField: 'desc',
          field: 'desc',
          minWidth: 200,
          flex: 1
        }
      ],
      columns: [
        {
          headerName: 'Mã đặt phòng',
          field: 'booking_code',
          tooltipField: 'booking_code',
          sortable: false,
          minWidth: 120
        },
        // {
        //   headerName: 'Hạng phòng',
        //   headerTooltip: 'Hạng phòng',
        //   field: 'room_level',
        //   tooltipField: 'room_level',
        //   sortable: false,
        //   minWidth: 120,
        //   maxWidth: 150
        // },
        {
          headerName: 'Tên phòng',
          headerTooltip: 'Tên phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          minWidth: 100,
          // width: 100,
          sortable: false
        },
        {
          headerName: 'Ngày đến',
          field: 'date_from',

          tooltipField: 'date_from',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: 'Ngày đi',
          field: 'date_to',
          tooltipField: 'date_to',

          sortable: false,
          minWidth: 120,
          maxWidth: 120
        },

        {
          headerName: 'Tên khách',
          headerTooltip: 'Tên khách',
          field: 'traveller_name',
          tooltipField: 'traveller_name',
          sortable: false,
          minWidth: 120
        },
        {
          headerName: 'Nguồn',
          field: 'source_name',
          tooltipField: 'source_name',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.agentName'),
          field: 'agent_name',
          sortable: false,
          minWidth: 170
        },
        {
          headerName: 'Số lượng khách',
          headerTooltip: 'Số lượng khách',
          field: 'num_of_guest',
          tooltipField: 'num_of_guest',
          sortable: false,
          minWidth: 80,
          maxWidth: 100
        },
        {
          headerName: 'Giá niêm yết',
          headerTooltip: 'Giá niêm yết',
          field: 'price',
          tooltipField: 'price',
          valueGetter: params => {
            if (params.node.rowPinned == undefined) {
              return this.$displayCurrency(+params.data.price)
            }
          },
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Dịch vụ buồng',
          headerTooltip: 'Dịch vụ buồng',
          field: 'r_service',
          tooltipField: 'r_service',
          valueGetter: params => {
            return this.$displayCurrency(+params.data.r_service)
          },
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Minibar',
          headerTooltip: 'Minibar',
          field: 'minibar',
          tooltipField: 'minibar',
          valueGetter: params => {
            return this.$displayCurrency(+params.data.minibar)
          },
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Giặt là',
          headerTooltip: 'Giặt là',
          field: 'laundry',
          tooltipField: 'laundry',
          valueGetter: params => {
            return this.$displayCurrency(+params.data.laundry)
          },
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Nhà hàng',
          headerTooltip: 'Nhà hàng',
          field: 'restaurant',
          tooltipField: 'restaurant',
          valueGetter: params => {
            return this.$displayCurrency(+params.data.restaurant)
          },
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Karaoke',
          headerTooltip: 'Karaoke',
          field: 'karaoke',
          tooltipField: 'karaoke',
          valueGetter: params => {
            return this.$displayCurrency(+params.data.karaoke)
          },
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Dịch vụ khác',
          headerTooltip: 'Dịch vụ khác',
          field: 'other',
          tooltipField: 'other',
          sortable: false,
          valueGetter: params => {
            return this.$displayCurrency(+params.data.other)
          },
          minWidth: 100
        },
        {
          headerName: 'Tổng miễn phí',
          headerTooltip: 'Tổng miễn phí',
          field: 'total',
          tooltipField: 'total',
          sortable: false,
          valueGetter: params => {
            return this.$displayCurrency(+params.data.total)
          },
          minWidth: 100
        }
      ],
      rows: [],
      columnsClick: null
    }
  },
  computed: {
    recode() {
      return this.searchParams.bookingCode
    }
  },
  watch: {
    recode: {
      handler(val) {
        // console.log(val, 'newwwwwwwwwwww')
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.dateFrom = null
          this.searchParams.dateTo = null
          this.searchParams.hotelId = []
          this.searchParams.sourceId = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.dateFrom = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  created() {},
  async mounted() {
    await this.getList()
    this.getListSource()
    this.getListHotel()
    this.fnGetAgentOptions()
  },

  methods: {
    clsAlphaNoOnly(e) {
      // Accept only alpha numerics, no special characters
      const regex = new RegExp('^[a-zA-Z0-9 ]+$')
      const str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      if (regex.test(str)) {
        return true
      }

      e.preventDefault()
      return false
    },
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    async fnGetAgentOptions() {
      const data = await getAgentListForReport()
      this.agentOptions = [{ id: null, code: 'Tất cả' }, ...data.data] || []
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getList() {
      this.loading = true
      this.rows = []
      await getFreeListApi(this.searchParams)
        .then(res => {
          const data = res?.data
          this.pinnedBottomRowData = [
            {
              source_name: 'Tổng',
              karaoke: res.karaoke,
              laundry: res.laundry,
              minibar: res.minibar,
              other: res.other,
              r_service: res.r_service,
              restaurant: res.restaurant,
              total: res.total
            }
          ]
          data.forEach(element => {
            this.rows = [
              ...this.rows,
              element,
              {
                name: ['Ghi chú: ', element.note].join(' '),
                isFullWidthRow: true
              }
            ]
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(error)
          })
        })
        .finally(() => {
          this.loading = false
          // this.fnSearchGroupList()
        })
    },
    async downloadExcel() {
      this.loading = true
      await getFreeListApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_chi_tiet_phong_mien_phi_' + date + '.xlsx')
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(error)
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.getList()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
